// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
  outline: none;
}

body {
  height: 100vh;
  overflow: hidden;
  color: #1E272E;
  font-size: 18px;
}

ul {
  list-style: none;
}

a {
  color: inherit;
}

.creditsMessage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(30, 39, 46, 0.65);
  z-index: 999999;
}
.creditsMessage > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 550px;
  height: 200px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.creditsMessage .top {
  display: flex;
  align-items: center;
  padding: 0 30px;
  height: 100%;
}
.creditsMessage .top > div {
  display: flex;
}
.creditsMessage .top span {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  background-color: rgba(224, 36, 36, 0.12);
  min-width: 45px;
  height: 45px;
  border-radius: 50%;
}
.creditsMessage .top span img {
  position: relative;
  top: -2px;
  width: 23px;
  height: 23px;
  object-fit: contain;
}
.creditsMessage .top h3 {
  margin-bottom: 5px;
  font-weight: 500;
}
.creditsMessage .top p {
  opacity: 0.7;
  line-height: 1.5;
}
.creditsMessage .action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 10px 30px;
  background-color: #F9FAFB;
  border-radius: 5px;
}
.creditsMessage .action a, .creditsMessage .action button {
  width: 90px;
  height: 35px;
  border-radius: 5px;
  font-size: 15px;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}
.creditsMessage .action button {
  margin-right: 10px;
  border-color: rgba(0, 0, 0, 0.2);
  background-color: #fff;
}
.creditsMessage .action button:hover {
  opacity: 0.65;
}
.creditsMessage .action a {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #40bf80;
  color: #fff;
  text-decoration: none;
}
.creditsMessage .action a:hover {
  opacity: 0.8;
}
.creditsMessage .action a:disabled {
  cursor: default;
  opacity: 0.75;
}

.deletePopup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(30, 39, 46, 0.65);
}
.deletePopup > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 500px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.deletePopup .info {
  display: flex;
  align-items: flex-start;
  padding: 30px;
}
.deletePopup .info > span {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  background-color: rgba(224, 36, 36, 0.12);
  min-width: 45px;
  min-height: 45px;
  border-radius: 50%;
}
.deletePopup .info > span img {
  position: relative;
  top: -2px;
  width: 23px;
  height: 23px;
  object-fit: contain;
}
.deletePopup .info h3 {
  margin-bottom: 5px;
  font-weight: 500;
}
.deletePopup .info p {
  opacity: 0.7;
  line-height: 1.4;
}
.deletePopup .action {
  text-align: right;
  width: 100%;
  padding: 10px 30px;
  background-color: #F9FAFB;
  border-radius: 5px;
}
.deletePopup .action button {
  width: 80px;
  height: 35px;
  border-radius: 5px;
  font-size: 15px;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}
.deletePopup .action button:first-of-type {
  margin-right: 10px;
  border-color: rgba(0, 0, 0, 0.2);
  background-color: #fff;
}
.deletePopup .action button:first-of-type:hover {
  opacity: 0.65;
}
.deletePopup .action button:last-of-type {
  background-color: #E02424;
  color: #fff;
}
.deletePopup .action button:last-of-type:hover {
  opacity: 0.8;
}
.deletePopup .action button:last-of-type:disabled {
  cursor: default;
  opacity: 0.75;
}

.btn1 {
  position: relative;
  width: 100%;
  min-height: 32px;
  height: 40px;
  border: 1px solid transparent;
  padding: 0 7.5px;
  border-radius: 10px;
  background-color: #3E82F8;
  color: #fff;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  font-size: 15px;
}
.btn1.line {
  margin-bottom: 20px;
}
.btn1.line::after {
  content: "";
  position: absolute;
  left: 0;
  top: calc(100% + 9px);
  width: 100%;
  height: 0.5px;
  background-color: rgb(220, 220, 220);
}
.btn1.withBorder {
  background-color: transparent;
  color: #339966;
  border-color: #339966;
}
.btn1.withBorder:hover {
  background-color: #339966;
  color: #fff;
  box-shadow: 0 0 10px #339966;
  border-color: transparent;
}
.btn1.withBorder:disabled:hover {
  background-color: transparent;
  color: #339966;
  border-color: #339966;
}
.btn1.withBorder.delete {
  margin-left: 7.5px;
  border-color: #E02424;
  color: #E02424;
}
.btn1.withBorder.delete:hover {
  background-color: #E02424;
  color: #fff;
  box-shadow: 0 0 5px #E02424;
}
.btn1.withBorder.delete:disabled:hover {
  background-color: transparent;
  color: #E02424;
  border-color: #E02424;
  box-shadow: 0 0 0;
}
.btn1:hover {
  box-shadow: 0 0 10px #3E82F8;
}
.btn1:disabled {
  opacity: 0.5;
  cursor: default;
}
.btn1:disabled:hover {
  box-shadow: 0 0 0;
}

.filesEdit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 50px;
  right: calc(100% + 30px);
  background-color: #fff;
  width: 180px;
  height: 200px;
  border-radius: 10px;
}
.filesEdit::before {
  content: "";
  position: absolute;
  right: -22px;
  width: 23px;
  height: 1px;
  background-color: #b1b1b7;
  z-index: 99;
}
.filesEdit .title {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(245, 245, 245);
  padding: 5px 7.5px;
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 10px 10px 0 0;
}
.filesEdit .scroll {
  padding: 8.5px 0 8.5px 7.5px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border: 1px solid rgb(220, 220, 220);
  border-top: none;
  border-radius: 0 0 10px 10px;
}
.filesEdit .checkbox {
  display: block;
  margin-bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  height: 186px;
}
.filesEdit .checkbox::-webkit-scrollbar {
  width: 0;
}
.filesEdit .checkbox > div {
  padding-top: 3.5px;
  margin-top: 0;
}
.filesEdit .checkbox > div span {
  width: 17px;
  height: 17px;
}
.filesEdit .checkbox > div span svg {
  font-size: 13px;
}
.filesEdit .checkbox > div label {
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 138px;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACG,sBAAA;EACA,SAAA;EACA,UAAA;EACA,iCAAA;EACA,aAAA;AACH;;AACA;EACG,aAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAEH;;AAAA;EACG,gBAAA;AAGH;;AADA;EAAI,cAAA;AAKJ;;AAHA;EACG,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,eAAA;AAMH;AAJG;EACG,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,wEAAA;AAMN;AAJG;EACG,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAMN;AAJM;EACG,aAAA;AAMT;AAJM;EACG,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAMT;AAJS;EACG,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAMZ;AAHM;EACG,kBAAA;EACA,gBAAA;AAKT;AAHM;EACG,YAAA;EACA,gBAAA;AAKT;AAFG;EACG,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAIN;AAFM;EACG,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;EACA,eAAA;AAIT;AAFM;EACG,kBAAA;EACA,gCAAA;EACA,sBAAA;AAIT;AAFS;EACG,aAAA;AAIZ;AADM;EACG,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;AAGT;AADS;EACG,YAAA;AAGZ;AADS;EACG,eAAA;EACA,aAAA;AAGZ;;AAGA;EACG,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;AAAH;AAEG;EACG,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,wEAAA;AAAN;AAEG;EACG,aAAA;EACA,uBAAA;EACA,aAAA;AAAN;AAEM;EACG,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAAT;AAES;EACG,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAAZ;AAGM;EACG,kBAAA;EACA,gBAAA;AADT;AAGM;EACG,YAAA;EACA,gBAAA;AADT;AAIG;EACG,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAFN;AAIM;EACG,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;EACA,eAAA;AAFT;AAIS;EACG,kBAAA;EACA,gCAAA;EACA,sBAAA;AAFZ;AAIY;EACG,aAAA;AAFf;AAKS;EACG,yBAAA;EACA,WAAA;AAHZ;AAKY;EACG,YAAA;AAHf;AAKY;EACG,eAAA;EACA,aAAA;AAHf;;AAUA;EACG,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;AAPH;AASG;EACG,mBAAA;AAPN;AASM;EACG,WAAA;EACA,kBAAA;EACA,OAAA;EACA,qBAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;AAPT;AAUG;EACG,6BAAA;EACA,cAAA;EACA,qBAAA;AARN;AAUM;EACG,yBAAA;EACA,WAAA;EACA,4BAAA;EACA,yBAAA;AART;AAUM;EACG,6BAAA;EACA,cAAA;EACA,qBAAA;AART;AAUM;EACG,kBAAA;EACA,qBAAA;EACA,cAAA;AART;AAUS;EACG,yBAAA;EACA,WAAA;EACA,2BAAA;AARZ;AAUS;EACG,6BAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AARZ;AAYG;EAEG,4BAAA;AAXN;AAaG;EACG,YAAA;EACA,eAAA;AAXN;AAaM;EACG,iBAAA;AAXT;;AAeA;EACG,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAZH;AAcG;EACG,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;AAZN;AAcG;EACG,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AAZN;AAcG;EACG,4BAAA;EACM,kFAAA;EAEN,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,4BAAA;AAbN;AAeG;EACG,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AAbN;AAeM;EACG,QAAA;AAbT;AAeM;EACG,kBAAA;EACA,aAAA;AAbT;AAeS;EACG,WAAA;EACA,YAAA;AAbZ;AAeY;EACG,eAAA;AAbf;AAgBS;EACG,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AAdZ","sourcesContent":["* {\r\n   box-sizing: border-box;\r\n   margin: 0;\r\n   padding: 0;\r\n   font-family: \"Roboto\", sans-serif;\r\n   outline: none;\r\n}\r\nbody {\r\n   height: 100vh;\r\n   overflow: hidden;\r\n   color: #1E272E;\r\n   font-size: 18px;\r\n}\r\nul {\r\n   list-style: none\r\n}\r\na { color: inherit; }\r\n\r\n.creditsMessage {\r\n   display: flex;\r\n   justify-content: center;\r\n   align-items: center;\r\n   position: absolute;\r\n   top: 0;\r\n   left: 0;\r\n   width: 100%;\r\n   height: 100%;\r\n   background-color: rgba(30, 39, 46, 0.65);\r\n   z-index: 999999;\r\n\r\n   > div {\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: space-between;\r\n      width: 550px;\r\n      height: 200px;\r\n      background-color: #fff;\r\n      border-radius: 5px;\r\n      box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\r\n   }\r\n   .top {\r\n      display: flex;\r\n      align-items: center;\r\n      padding: 0 30px;\r\n      height: 100%;\r\n\r\n      > div {\r\n         display: flex;\r\n      }\r\n      span {\r\n         display: flex;\r\n         align-items: center;\r\n         justify-content: center;\r\n         margin-right: 20px;\r\n         background-color: rgba(224, 36, 36, 0.12);\r\n         min-width: 45px;\r\n         height: 45px;\r\n         border-radius: 50%;\r\n\r\n         img {\r\n            position: relative;\r\n            top: -2px;\r\n            width: 23px;\r\n            height: 23px;\r\n            object-fit: contain;\r\n         }\r\n      }\r\n      h3 {\r\n         margin-bottom: 5px;\r\n         font-weight: 500;\r\n      }\r\n      p {\r\n         opacity: 0.7;\r\n         line-height: 1.5;\r\n      }\r\n   }\r\n   .action {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: flex-end;\r\n      width: 100%;\r\n      padding: 10px 30px;\r\n      background-color: #F9FAFB;\r\n      border-radius: 5px;\r\n\r\n      a, button {\r\n         width: 90px;\r\n         height: 35px;\r\n         border-radius: 5px;\r\n         font-size: 15px;\r\n         border: 1px solid transparent;\r\n         transition: all .2s ease-in-out;\r\n         cursor: pointer;\r\n      }\r\n      button {\r\n         margin-right: 10px;\r\n         border-color: rgba(0, 0, 0, 0.2);\r\n         background-color: #fff;\r\n\r\n         &:hover {\r\n            opacity: 0.65;\r\n         }\r\n      }\r\n      a {\r\n         display: flex;\r\n         align-items: center;\r\n         justify-content: center;\r\n         background-color: #40bf80;\r\n         color: #fff;\r\n         text-decoration: none;\r\n\r\n         &:hover {\r\n            opacity: 0.8;\r\n         }\r\n         &:disabled {\r\n            cursor: default;\r\n            opacity: 0.75;\r\n         }\r\n      }\r\n   }\r\n}\r\n\r\n.deletePopup {\r\n   display: flex;\r\n   justify-content: center;\r\n   align-items: center;\r\n   position: absolute;\r\n   top: 0;\r\n   left: 0;\r\n   width: 100%;\r\n   height: 100%;\r\n   background-color: rgba(30, 39, 46, 0.65);\r\n\r\n   > div {\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: space-between;\r\n      width: 500px;\r\n      background-color: #fff;\r\n      border-radius: 5px;\r\n      box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\r\n   }\r\n   .info {\r\n      display: flex;\r\n      align-items: flex-start;\r\n      padding: 30px;\r\n\r\n      > span {\r\n         display: flex;\r\n         align-items: center;\r\n         justify-content: center;\r\n         margin-right: 20px;\r\n         background-color: rgba(224, 36, 36, 0.12);\r\n         min-width: 45px;\r\n         min-height: 45px;\r\n         border-radius: 50%;\r\n\r\n         img {\r\n            position: relative;\r\n            top: -2px;\r\n            width: 23px;\r\n            height: 23px;\r\n            object-fit: contain;\r\n         }\r\n      }\r\n      h3 {\r\n         margin-bottom: 5px;\r\n         font-weight: 500;\r\n      }\r\n      p {\r\n         opacity: 0.7;\r\n         line-height: 1.4;\r\n      }\r\n   }\r\n   .action {\r\n      text-align: right;\r\n      width: 100%;\r\n      padding: 10px 30px;\r\n      background-color: #F9FAFB;\r\n      border-radius: 5px;\r\n\r\n      button {\r\n         width: 80px;\r\n         height: 35px;\r\n         border-radius: 5px;\r\n         font-size: 15px;\r\n         border: 1px solid transparent;\r\n         transition: all .2s ease-in-out;\r\n         cursor: pointer;\r\n\r\n         &:first-of-type {\r\n            margin-right: 10px;\r\n            border-color: rgba(0, 0, 0, 0.2);\r\n            background-color: #fff;\r\n\r\n            &:hover {\r\n               opacity: 0.65;\r\n            }\r\n         }\r\n         &:last-of-type {\r\n            background-color: #E02424;\r\n            color: #fff;\r\n\r\n            &:hover {\r\n               opacity: 0.8;\r\n            }\r\n            &:disabled {\r\n               cursor: default;\r\n               opacity: 0.75;\r\n            }\r\n         }\r\n      }\r\n   }\r\n}\r\n\r\n.btn1 {\r\n   position: relative;\r\n   width: 100%;\r\n   min-height: 32px;\r\n   height: 40px;\r\n   border: 1px solid transparent;\r\n   padding: 0 7.5px;\r\n   border-radius: 10px;\r\n   background-color: #3E82F8;\r\n   color: #fff;\r\n   transition: all .2s ease-in-out;\r\n   cursor: pointer;\r\n   font-size: 15px;\r\n\r\n   &.line {\r\n      margin-bottom: 20px;\r\n   \r\n      &::after {\r\n         content: '';\r\n         position: absolute;\r\n         left: 0;\r\n         top: calc(100% + ((20px / 2) - 1px));\r\n         width: 100%;\r\n         height: 0.5px;\r\n         background-color: rgb(220, 220, 220);\r\n      }\r\n   }\r\n   &.withBorder {\r\n      background-color: transparent;\r\n      color: #339966;\r\n      border-color: #339966;\r\n\r\n      &:hover {\r\n         background-color: #339966;\r\n         color: #fff;\r\n         box-shadow: 0 0 10px #339966;\r\n         border-color: transparent;\r\n      }\r\n      &:disabled:hover {\r\n         background-color: transparent;\r\n         color: #339966;\r\n         border-color: #339966;\r\n      } \r\n      &.delete {\r\n         margin-left: 7.5px;\r\n         border-color: #E02424;\r\n         color: #E02424;\r\n\r\n         &:hover {\r\n            background-color: #E02424;\r\n            color: #fff;\r\n            box-shadow: 0 0 5px #E02424;\r\n         }\r\n         &:disabled:hover {\r\n            background-color: transparent;\r\n            color: #E02424;\r\n            border-color: #E02424;\r\n            box-shadow: 0 0 0;\r\n         } \r\n      }\r\n   }\r\n   &:hover {\r\n      // background-color: #3875df;\r\n      box-shadow: 0 0 10px #3E82F8;\r\n   }\r\n   &:disabled {\r\n      opacity: 0.5;\r\n      cursor: default;\r\n      \r\n      &:hover {\r\n         box-shadow: 0 0 0;\r\n      }\r\n   }\r\n}\r\n.filesEdit {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: center;\r\n   position: absolute;\r\n   top: 50px;\r\n   right: calc(100% + 30px);\r\n   background-color: #fff;\r\n   width: 180px;\r\n   height: 200px;\r\n   border-radius: 10px;\r\n\r\n   &::before {\r\n      content: '';\r\n      position: absolute;\r\n      right: -22px;\r\n      width: 23px;\r\n      height: 1px;\r\n      background-color: #b1b1b7;\r\n      z-index: 99;\r\n   }\r\n   .title {\r\n      position: relative;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      background-color: rgb(245, 245, 245);\r\n      padding: 5px 7.5px;\r\n      height: 30px;\r\n      font-size: 16px;\r\n      font-weight: 400;\r\n      border-radius: 10px 10px 0 0;\r\n   }\r\n   .scroll {\r\n      padding: 8.5px 0 8.5px 7.5px;\r\n            box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\r\n\r\n      background-color: #fff;\r\n      border: 1px solid rgb(220, 220, 220);\r\n      border-top: none;\r\n      border-radius: 0 0 10px 10px;\r\n   }\r\n   .checkbox {\r\n      display: block;\r\n      margin-bottom: 0;\r\n      overflow-y: auto;\r\n      overflow-x: hidden;\r\n      height: 186px;\r\n\r\n      &::-webkit-scrollbar {\r\n         width: 0;\r\n      }\r\n      > div {\r\n         padding-top: 3.5px;\r\n         margin-top: 0;\r\n         \r\n         span {\r\n            width: 17px;\r\n            height: 17px;\r\n\r\n            svg {\r\n               font-size: 13px;\r\n            }\r\n         }\r\n         label {\r\n            font-size: 16px;\r\n            white-space: nowrap;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            width: calc(180px - 17px - 10px - 15px);\r\n         }\r\n      }\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
